export enum PublicInformationPageMessageTypes {
    DISCOUNT = "discount",
    QR_NOT_FOUND = "qr-not-found",
    QR_IS_DISABLED = "qr-is-disabled",
    QR_IS_SCANNABLE = "qr-is-scannable",
    QR_VISITS_REACHED = "qr-visits-reached",
    NEWSLETTERS_UNSUBSCRIPTION = "newsletters/unsubscribed"
}